class ProductUpsellVariantSelector extends HTMLElement {
	constructor() {
		super();

		this.product = JSON.parse(this.dataset.product || "{}");

		this.cartDrawer = this.closest("cart-drawer");
		this.isDrawer = !!this.cartDrawer;

		const upsellItem = this.closest(".product-upsell-item");
		if (!upsellItem) {
			return;
		}

		this.variantSelects = upsellItem.querySelector(
			".product-upsell-item__variants",
		);

		if (this.isDrawer) {
			this.cartItems = this.cartDrawer?.querySelector("cart-drawer-items");
		}

		this.form = this.querySelector("form");
		this.idInput = this.querySelector('[name="id"]');
		this.submitButton = this.querySelector('button[type="submit"]');

		this.jsonData = this.querySelector('script[type="application/json"]');

		if (this.variantSelects) {
			this.selectElements = this.variantSelects.querySelectorAll("select");

			this.radioElements = this.variantSelects.querySelectorAll(
				'input[type="radio"]',
			);

			this.setupEventListeners();
		}

		if (this.form) {
			this.form.addEventListener("submit", this.onSubmit.bind(this));
		}

		this.handle = this.product.handle;
	}

	setupEventListeners() {
		const handler = this.handleVariantChange.bind(this);

		if (this.selectElements) {
			this.selectElements.forEach((select) => {
				select.addEventListener("change", handler);
			});
		}

		if (this.radioElements && this.radioElements.length > 0) {
			this.radioElements.forEach((radio) => {
				radio.addEventListener("change", handler);
				radio.addEventListener("click", handler);
			});
		}
	}

	handleVariantChange() {
		const variant = this.getSelectedVariant();
		if (!variant) return;

		this.updateVariantId(variant.id);
		this.updateButtonState(variant.available);
		this.updateProductImage(variant.featured_image);
	}

	getSelectedVariant() {
		if (this.selectElements && this.selectElements.length > 0) {
			const variantId = this.selectElements[0].value;
			if (variantId) {
				return this.getVariantData().find(
					(v) => v.id.toString() === variantId.toString(),
				);
			}
		}

		if (this.radioElements && this.radioElements.length > 0) {
			const checkedRadios = Array.from(this.radioElements).filter(
				(radio) => radio.checked,
			);

			if (checkedRadios.length === 0) {
				return null;
			}

			const optionValues = {};
			checkedRadios.forEach((radio) => {
				optionValues[radio.name] = radio.value;
			});

			return this.getVariantData().find((variant) => {
				return this.product.options.every((option, index) => {
					const selectedValue = optionValues[option];

					if (!selectedValue) {
						return true;
					}

					return variant.options[index] === selectedValue;
				});
			});
		}

		return null;
	}

	updateVariantId(variantId) {
		if (this.idInput) {
			this.idInput.value = variantId;
			this.dataset.id = variantId;
		}
	}

	updateButtonState(available) {
		if (!this.submitButton) return;

		if (available) {
			this.submitButton.removeAttribute("disabled");
		} else {
			this.submitButton.setAttribute("disabled", "disabled");
		}
	}

	updateProductImage(featuredImage) {
		if (!featuredImage) return;

		const upsellItem = this.closest(".product-upsell-item");
		if (!upsellItem) return;

		const productImage = upsellItem.querySelector(
			".product-upsell-item__image img",
		);
		if (productImage) {
			productImage.src = featuredImage.src;
		}
	}

	getVariantData() {
		if (!this.variantData && this.jsonData) {
			this.variantData = JSON.parse(this.jsonData.textContent);
		}
		return this.variantData || [];
	}

	onSubmit(event) {
		event.preventDefault();
		this.addToCart();
	}

	addToCart() {
		if (this.submitButton) {
			this.submitButton.classList.add("loading");
			this.submitButton.setAttribute("disabled", "disabled");
			const spinner = this.submitButton.querySelector(
				".loading-overlay__spinner",
			);
			if (spinner) spinner.classList.remove("hidden");
		}

		if (this.selectElements) {
			this.selectElements.forEach((select) => {
				select.setAttribute("disabled", "disabled");
			});
		}

		const cartDrawer = document.querySelector("cart-drawer");
		const shouldOpenDrawer = this.dataset.openDrawer === "true";

		const formData = new FormData(this.form);

		if (shouldOpenDrawer && cartDrawer) {
			const sections = cartDrawer.getSectionsToRender().map((s) => s.id);
			formData.append("sections", sections);
			formData.append("sections_url", window.location.pathname);
		}

		const config = {
			method: "POST",
			body: formData,
		};

		config.headers = {
			"X-Requested-With": "XMLHttpRequest",
			Accept: "application/javascript",
		};

		fetch(`${window.Shopify.routes.root}cart/add.js`, config)
			.then((response) => response.json())
			.then((data) => {
				if (
					typeof publish !== "undefined" &&
					typeof PUB_SUB_EVENTS !== "undefined"
				) {
					publish(PUB_SUB_EVENTS.cartUpdate, {
						source: "upsell-variant-selector",
						cartData: data,
					});
				} else {
					document.dispatchEvent(
						new CustomEvent("cart:updated", {
							detail: {
								cartData: data,
							},
						}),
					);
				}

				if (shouldOpenDrawer && cartDrawer && data.sections) {
					if (cartDrawer.classList.contains("is-empty")) {
						cartDrawer.classList.remove("is-empty");
					}

					cartDrawer.renderContents(data, false);
				}

				if (this.submitButton) {
					this.submitButton.classList.remove("loading");
					this.submitButton.removeAttribute("disabled");
					const spinner = this.submitButton.querySelector(
						".loading-overlay__spinner",
					);
					if (spinner) spinner.classList.add("hidden");
				}

				if (this.selectElements) {
					this.selectElements.forEach((select) => {
						select.removeAttribute("disabled");
					});
				}
			})
			.catch((error) => {
				console.error("Error adding to cart:", error);

				if (this.submitButton) {
					this.submitButton.classList.remove("loading");
					this.submitButton.removeAttribute("disabled");
					const spinner = this.submitButton.querySelector(
						".loading-overlay__spinner",
					);
					if (spinner) spinner.classList.add("hidden");
				}

				if (this.selectElements) {
					this.selectElements.forEach((select) => {
						select.removeAttribute("disabled");
					});
				}
			});
	}

	updateCartCount() {
		fetch(`${window.Shopify.routes.root}cart.js`)
			.then((response) => response.json())
			.then((cart) => {
				const cartCountElements = document.querySelectorAll(
					'.cart-count-bubble span[aria-hidden="true"]',
				);
				cartCountElements.forEach((el) => {
					el.textContent = cart.item_count;
				});

				const cartCountAccessibleElements = document.querySelectorAll(
					'.cart-count-bubble span:not([aria-hidden="true"])',
				);
				cartCountAccessibleElements.forEach((el) => {
					el.textContent =
						cart.item_count === 1
							? window.accessibilityStrings.cartSingularAccessibilityString
							: window.accessibilityStrings.cartPluralAccessibilityString.replace(
									"[count]",
									cart.item_count,
								);
				});
			});
	}
}

customElements.define(
	"product-upsell-variant-selector",
	ProductUpsellVariantSelector,
);
